try{history.scrollRestoration="manual"}catch(e){}document.documentElement.classList.add("js")
;
(() => {
  'use strict';
  const reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reduce = reduceMQ.matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const hasIO = 'IntersectionObserver' in window;

  /* ---- Aurora: pointer parallax on one compositor transform (fine pointers only) ---- */
  const layer = document.getElementById('auroraLayer');
  if (layer && !reduce && finePointer) {
    let atx = 0, aty = 0, acx = 0, acy = 0, araf = 0;
    const atick = () => {
      acx += (atx - acx) * 0.06; acy += (aty - acy) * 0.06;
      layer.style.setProperty('--px', acx.toFixed(2) + 'px');
      layer.style.setProperty('--py', acy.toFixed(2) + 'px');
      if (Math.abs(atx - acx) > 0.1 || Math.abs(aty - acy) > 0.1) araf = requestAnimationFrame(atick); else araf = 0;
    };
    window.addEventListener('pointermove', (e) => {
      atx = (e.clientX / window.innerWidth - 0.5) * -36;
      aty = (e.clientY / window.innerHeight - 0.5) * -28;
      if (!araf) araf = requestAnimationFrame(atick);
    }, { passive: true });
  }

  /* ---- Hook headlines: split into words for the word-by-word reveal ---- */
  document.querySelectorAll('[data-hook]').forEach(h => {
    const parts = [];
    h.childNodes.forEach(n => {
      if (n.nodeType === 3) n.textContent.split(/\s+/).filter(Boolean).forEach(w => parts.push({ t: w, van: false }));
      else if (n.nodeType === 1) n.textContent.split(/\s+/).filter(Boolean).forEach(w => parts.push({ t: w, van: n.classList.contains('van') }));
    });
    h.textContent = '';
    parts.forEach((p, i) => {
      const w = document.createElement('span'); w.className = 'w' + (p.van ? ' van' : '');
      const inner = document.createElement('i'); inner.style.setProperty('--i', i); inner.textContent = p.t;
      w.appendChild(inner); h.appendChild(w); h.appendChild(document.createTextNode(' '));
    });
  });

  /* ---- Scroll reveal (rv, rise, hook, cyc) ---- */
  const rv = document.querySelectorAll('.rv, .rise, .hook, .cyc, .pl, .fly, .stp');
  if (reduce || !hasIO) {
    rv.forEach(el => el.classList.add('in'));
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    rv.forEach(el => io.observe(el));
  }

  /* ---- Horizontal lanes (club posts, challenge pair, bento on phones): reveal every card when the lane itself arrives ---- */
  if (hasIO && !reduce) {
    const lio = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (!e.isIntersecting) return; e.target.querySelectorAll('.fly, .rv, .rise, .tile').forEach(el => el.classList.add('in')); lio.unobserve(e.target); });
    }, { threshold: 0.15 });
    document.querySelectorAll('.posts, .art-two, .bento, .plans, .chap-row').forEach(l => lio.observe(l));
  }

  /* ---- Animated numbers ---- */
  // числа — в формате языка страницы («1 480», «74,0» на ru); цены (data-en-num) — всегда en-US: $4.99 на всех языках
  const fmt = (v, dec, loc) => v.toLocaleString(loc, { minimumFractionDigits: dec, maximumFractionDigits: dec });
  const runCount = (el) => {
    if (el.dataset.done) return; el.dataset.done = '1';
    const target = parseFloat(el.dataset.count);
    const dec = parseInt(el.dataset.decimals || '0', 10);
    const loc = el.hasAttribute('data-en-num') ? 'en-US' : (document.documentElement.lang || 'en-US');
    if (reduce) { el.textContent = fmt(target, dec, loc); return; }
    const dur = 1400, t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const e = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt(target * e, dec, loc);
      if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target, dec, loc);
    };
    requestAnimationFrame(step);
  };
  const counters = document.querySelectorAll('[data-count]');
  if (hasIO) {
    const cio = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.08 });
    counters.forEach(el => cio.observe(el));
  } else { counters.forEach(runCount); }

  /* ---- Premium animateEntry: rings and macro bars draw on entry ---- */
  const seen = new WeakSet();
  const animateEntry = (el) => {
    if (seen.has(el) || reduce) return; seen.add(el);
    el.querySelectorAll('.ring-value').forEach(ring => { const dash = ring.getAttribute('stroke-dasharray'); ring.animate([{ strokeDasharray: '0 100' }, { strokeDasharray: dash }], { duration: 1400, easing: 'cubic-bezier(.22,1,.36,1)' }); });
    el.querySelectorAll('.macro-bars i').forEach(bar => bar.animate([{ transform: 'scaleX(0)', transformOrigin: 'left' }, { transform: 'scaleX(1)', transformOrigin: 'left' }], { duration: 1000, easing: 'cubic-bezier(.22,1,.36,1)' }));
  };
  const motionSections = [...document.querySelectorAll('[data-motion-section], .stage')];
  if (hasIO) {
    const mo = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('in-view'); animateEntry(entry.target); mo.unobserve(entry.target); } }), { threshold: 0.08 });
    motionSections.forEach(el => mo.observe(el));
  } else motionSections.forEach(el => { el.classList.add('in-view'); animateEntry(el); });

  /* ---- Hero stage: pointer parallax on the phone and floating cards (transform only) ---- */
  const stage = document.getElementById('stage');
  if (stage && !reduce && finePointer) {
    const layers = [...stage.querySelectorAll('[data-depth]')];
    let tx = 0, ty = 0, tick = false;
    const apply = () => { tick = false; layers.forEach(l => { const d = parseFloat(l.dataset.depth) || .5; l.style.setProperty('--py', (ty * 10 * d).toFixed(1) + 'px'); }); };
    stage.addEventListener('pointermove', (e) => { const r = stage.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width - .5; ty = (e.clientY - r.top) / r.height - .5; if (!tick) { tick = true; requestAnimationFrame(apply); } }, { passive: true });
    stage.addEventListener('pointerleave', () => { tx = 0; ty = 0; requestAnimationFrame(apply); });
  }

  /* ---- Magnetic buttons (transform only, 60px pull radius) ---- */
  if (!reduce && finePointer) {
    const mags = Array.from(document.querySelectorAll('[data-magnetic]'));
    const R = 60, PULL = .32;
    let px = 0, py = 0, ticking = false;
    const update = () => {
      ticking = false;
      for (const el of mags) {
        const r = el.getBoundingClientRect();
        if (r.bottom < -R || r.top > innerHeight + R) { if (el.classList.contains('live')) { el.classList.remove('live'); el.style.setProperty('--mx','0px'); el.style.setProperty('--my','0px'); } continue; }
        const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        const dx = px - cx, dy = py - cy;
        const ox = Math.max(Math.abs(dx) - r.width / 2, 0), oy = Math.max(Math.abs(dy) - r.height / 2, 0);
        const d = Math.hypot(ox, oy);
        if (d < R) {
          const s = 1 - d / R;
          el.classList.add('live');
          el.style.setProperty('--mx', (dx * PULL * s).toFixed(1) + 'px');
          el.style.setProperty('--my', (dy * PULL * s).toFixed(1) + 'px');
        } else if (el.classList.contains('live')) {
          el.classList.remove('live');
          el.style.setProperty('--mx', '0px'); el.style.setProperty('--my', '0px');
        }
      }
    };
    window.addEventListener('pointermove', (e) => { px = e.clientX; py = e.clientY; if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('pointerleave', () => { px = -9999; py = -9999; requestAnimationFrame(update); });
  }

  /* ---- Typing fields (Karina card + bento tile) ---- */
  const typeInto = (el, trigger, lines) => {
    if (!el || !trigger) return;
    if (reduce) { el.textContent = lines[0]; return; }
    let li = 0, ci = lines[0].length, del = false, started = false;
    const tick = () => {
      const s = lines[li];
      if (!del) { ci++; el.textContent = s.slice(0, ci); if (ci >= s.length) { del = true; setTimeout(tick, 2000); return; } }
      else { ci--; el.textContent = s.slice(0, ci); if (ci <= 0) { del = false; li = (li + 1) % lines.length; setTimeout(tick, 420); return; } }
      setTimeout(tick, del ? 26 : 48 + Math.random() * 60);
    };
    if (hasIO) {
      const kio = new IntersectionObserver((es) => { if (es[0].isIntersecting && !started) { started = true; del = true; setTimeout(tick, 1600); kio.disconnect(); } }, { threshold: 0.08 });
      kio.observe(trigger);
    }
  };
  typeInto(document.getElementById('kar-ask'), document.querySelector('.kar'), ['Ask Karina', 'What does ferritin usually mean?', 'I drank a glass of water', 'Ideas for a light dinner?', 'How many steps today?']);
  typeInto(document.getElementById('bx-ask'), document.querySelector('.bx .kar'), ['Ask Karina', 'I slept five hours. What should lunch look like?', 'Two glasses of water, note it.', 'Cycle today?']);

  /* ---- Bento counters (data-bx-count) ---- */
  const bxFmt = (v, dec) => (dec ? v : Math.round(v)).toLocaleString(document.documentElement.lang || 'en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  const bxCount = (el) => {
    if (el.dataset.done) return; el.dataset.done = '1';
    const to = parseFloat(el.dataset.bxCount), from = parseFloat(el.dataset.from || '0');
    const dec = parseInt(el.dataset.dec || '0', 10), dur = parseInt(el.dataset.dur || '1400', 10);
    if (reduce) { el.textContent = bxFmt(to, dec); return; }
    let t0 = null;
    const step = (t) => { if (t0 === null) t0 = t; const p = Math.min(1, (t - t0) / dur); const e = 1 - Math.pow(1 - p, 4); el.textContent = bxFmt(from + (to - from) * e, dec); if (p < 1) requestAnimationFrame(step); };
    setTimeout(() => requestAnimationFrame(step), 350);
  };
  const tiles = document.querySelectorAll('.bx .tile');
  if (hasIO) {
    const bio = new IntersectionObserver((es) => { es.forEach(e => { if (!e.isIntersecting) return; e.target.querySelectorAll('[data-bx-count]').forEach(bxCount); bio.unobserve(e.target); }); }, { threshold: 0.08 });
    tiles.forEach(t => bio.observe(t));
  } else { tiles.forEach(t => t.querySelectorAll('[data-bx-count]').forEach(bxCount)); }

  /* ---- Hydration demo (ported from premium.js: renderWater / changeWater / tween) ---- */
  const activeTweens = new Map();
  function tween(key, from, to, paint, duration = 1000) {
    const previous = activeTweens.get(key); if (previous) cancelAnimationFrame(previous.frame);
    if (reduceMQ.matches || document.hidden) { paint(to); activeTweens.delete(key); return; }
    const start = performance.now(), entry = { frame: 0, finish: () => paint(to) };
    function step(now) { const t = Math.min((now - start) / duration, 1); paint(from + (to - from) * (1 - Math.pow(1 - t, 3))); if (t < 1) { entry.frame = requestAnimationFrame(step); } else { activeTweens.delete(key); } }
    activeTweens.set(key, entry); entry.frame = requestAnimationFrame(step);
  }
  function finishAnimations() { for (const entry of activeTweens.values()) { cancelAnimationFrame(entry.frame); entry.finish(); } activeTweens.clear(); }
  const water = document.getElementById('hy');
  if (water) {
    const fill = document.getElementById('hy-fill');
    const amount = document.getElementById('water-number'), remaining = document.getElementById('water-remaining');
    const status = document.getElementById('water-message');
    const minus = document.getElementById('water-minus'), plus = document.getElementById('water-plus');
    let total = 1500, displayed = 1500, portion = 250, waterStarted = false;
    function renderWater(animate = true, announce = false) {
      const target = total;
      fill.style.transform = `translateY(${100 - Math.min(target / 2000, 1) * 100}%)`;
      water.classList.toggle('complete', target >= 2000);
      const paint = v => { displayed = v; amount.textContent = (v / 1000).toLocaleString(document.documentElement.lang || 'en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }); };
      if (animate) tween('water', displayed, target, paint, 800); else paint(target);
      remaining.textContent = target >= 2000 ? 'Your daily goal is complete' : 'Just {n} ml to your goal'.replace('{n}', (2000 - target).toLocaleString(document.documentElement.lang || 'en-US'));
      minus.disabled = target === 0; plus.disabled = target >= 2000;
      if (announce) status.textContent = target >= 2000 ? 'Goal reached. A small moment worth celebrating.' : '{n} ml of 2,000 ml · {p} % complete'.replace('{n}', target.toLocaleString(document.documentElement.lang || 'en-US')).replace('{p}', Math.round(target / 20));
      else status.textContent = 'Make room for one small habit.';
    }
    function changeWater(delta) { waterStarted = true; total = Math.max(0, Math.min(2000, total + delta)); renderWater(true, true); }
    minus.addEventListener('click', () => changeWater(-portion)); plus.addEventListener('click', () => changeWater(portion));
    const portionNames = { 100: 'Small glass', 200: 'Glass', 250: 'Large glass', 330: 'Small bottle', 500: 'Bottle', 750: 'Large bottle' };
    document.querySelectorAll('[data-portion]').forEach(button => button.addEventListener('click', () => {
      portion = Number(button.dataset.portion);
      document.querySelectorAll('[data-portion]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      document.getElementById('portion-label').textContent = '{t} · {n} ml'.replace('{t}', portionNames[portion]).replace('{n}', portion);
    }));
    document.getElementById('water-reset').addEventListener('click', () => { waterStarted = true; total = 0; renderWater(true, true); });
    renderWater(false);
    if (hasIO) {
      const wio = new IntersectionObserver(entries => entries.forEach(entry => {
        water.classList.toggle('in-view', entry.isIntersecting);
        if (entry.isIntersecting && !waterStarted) { waterStarted = true; displayed = 0; renderWater(true); }
      }), { threshold: 0.08 });
      wio.observe(water);
    } else water.classList.add('in-view');
  }

  /* ---- Food photo demo (ported): Capture -> Analyse -> Review ---- */
  const food = document.querySelector('.food-demo');
  if (food) {
    const fstatus = food.querySelector('.food-screen-status'), steps = [...food.querySelectorAll('[data-food-step]')];
    let timers = [], played = false;
    function state(s, i) { food.dataset.state = s; steps.forEach((x, n) => x.classList.toggle('active', n === i)); fstatus.textContent = s === 'analyse' ? 'Analysing your meal…' : 'Ready to capture'; }
    function play() {
      timers.forEach(clearTimeout); timers = []; played = true;
      if (reduceMQ.matches) { state('review', 2); return; }
      state('ready', 0);
      timers.push(setTimeout(() => state('capture', 0), 700), setTimeout(() => state('analyse', 1), 1150), setTimeout(() => state('review', 2), 3800));
    }
    food.querySelector('[data-food-replay]').addEventListener('click', play);
    state('review', 2);
    if (hasIO) { const fio = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting) && !played) { play(); fio.disconnect(); } }, { threshold: 0.08 }); fio.observe(food); }
    document.addEventListener('visibilitychange', () => { if (document.hidden) { timers.forEach(clearTimeout); state('review', 2); } });
  }

  /* ---- Meditation: pause the breathing circles ---- */
  const calm = document.getElementById('calm');
  if (calm) {
    const calmButton = calm.querySelector('button');
    calmButton.addEventListener('click', () => { const paused = calm.classList.toggle('paused'); calmButton.setAttribute('aria-pressed', String(paused)); calmButton.textContent = paused ? 'Resume animation' : 'Pause animation'; });
  }

  document.addEventListener('visibilitychange', () => { if (document.hidden) finishAnimations(); });
  reduceMQ.addEventListener('change', () => { if (reduceMQ.matches) { finishAnimations(); document.getAnimations().forEach(a => a.finish()); } });

  /* ---- FAQ ---- */
  document.querySelectorAll('.faq button').forEach(btn => {
    btn.addEventListener('click', () => {
      const li = btn.closest('li');
      const open = li.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();
;
/* Волна веса: чистый CSS (см. .wt-wave), JS не нужен */
;
(function(){var h=document.documentElement;function top(){h.classList.remove("smooth");var id=location.hash.slice(1),el=id&&id!=="signin"&&document.getElementById(id);if(el)el.scrollIntoView();else if(!id||id==="signin")scrollTo(0,0)}top();addEventListener("pageshow",function(e){if(e.persisted)top()});document.addEventListener("click",function(e){var a=e.target&&e.target.closest&&e.target.closest('a[href^="#"]');if(a)h.classList.add("smooth")},true)})();
;
(function(){function play(){document.querySelectorAll("video[autoplay]").forEach(function(v){v.muted=true;var p=v.play();if(p&&p.catch)p.catch(function(){});});}play();addEventListener("scroll",play,{once:true,passive:true});addEventListener("touchstart",play,{once:true,passive:true});})();
;
(function(){document.querySelectorAll("[data-theme-switch]").forEach(function(a){a.setAttribute("href",a.getAttribute("href")+location.search+location.hash)})})();
;
(function(){function sweep(){document.querySelectorAll('.rv:not(.in)').forEach(function(e){var r=e.getBoundingClientRect();if(r.top<innerHeight*1.05&&r.bottom>-40)e.classList.add('in')})}addEventListener('scroll',sweep,{passive:true});addEventListener('load',function(){sweep();setTimeout(sweep,600)});setInterval(sweep,1500)})();
;
(function(){document.querySelectorAll('.plans .plan').forEach(function(pl){var b=document.createElement('button');b.type='button';b.className='pl-more';b.textContent="What's inside";var price=pl.querySelector('.as-price');(price?price:pl.firstElementChild).insertAdjacentElement('afterend',b);b.addEventListener('click',function(){pl.classList.toggle('open');b.textContent=pl.classList.contains('open')?'Hide details':"What's inside"})})})();
;
(function(){/* шапка по месту — ступени описаны в стилях («шапка по месту») */var h=document.documentElement,w=document.querySelector('.nav .wrap');if(!w)return;var b=w.querySelector('.brand'),u=w.querySelector('.nav-links'),r=w.querySelector('.nav-right');if(!b||!r)return;var S=['nav-tight','nav-fold','nav-compact'];function gap(a,c){return c.getBoundingClientRect().left-a.getBoundingClientRect().right}function fits(){if(r.getBoundingClientRect().right>h.clientWidth)return false;if(u&&u.offsetWidth)return gap(b,u)>=24&&gap(u,r)>=24;return gap(b,r)>=12}function fit(){S.forEach(function(c){h.classList.remove(c)});for(var i=0;i<S.length&&!fits();i++)h.classList.add(S[i])}fit();if(window.ResizeObserver)new ResizeObserver(fit).observe(w);else addEventListener('resize',fit);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fit)})()
;
/* ---- Shopify: кнопки пакетов кладут товар в корзину (владелец 14.09) ---- */
(function () {
  var forms = document.querySelectorAll('form[data-plan-buy]');
  if (!forms.length || !window.fetch || !window.FormData) return;
  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';
  forms.forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn.disabled) return;
      btn.disabled = true;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
      }
      fetch(routes.cart_add_url || '/cart/add', { method: 'POST', body: fd, headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { location.href = form.getAttribute('data-product-url') || cartUrl; return; }
          if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: fd.get('id'), cartData: res });
          if (cart && typeof cart.renderContents === 'function') { cart.renderContents(res); cart.classList.remove('is-empty'); }
          else location.href = cartUrl;
        })
        .catch(function () { location.href = cartUrl; })
        .finally(function () { btn.disabled = false; });
    });
  });
})();
